<template>
    <div>
        <loader-component v-if="showLoader"></loader-component> 
        <div v-else class="wrapper-parent">
            <selected-cart-modal></selected-cart-modal>
            <responsive-header-component></responsive-header-component>
            <!-- responsive-header -->
            <div class="wrapper default">
                <!-- header -->
                <header class="main-header default">
                    <div class="container">
                        <header-component></header-component>
                    </div>
                    <navbar3-component></navbar3-component>
                </header>
                <!-- header -->
                <main class="content-main default">
                    <div style="background-color:#fff" class="container no-padding-right no-padding-left">
                        <router-view></router-view>
                    </div>
                </main>
                <footer-component></footer-component>
                <!--<footer-fixnav-component></footer-fixnav-component>-->
            </div>
        </div>

    </div>
</template>

<script>
    
    import { initialSite } from "../../module/initialSite";
    export default {
        data() {
            return {
               showLoader: false
            }
        }, 
        beforeMount: function () {
            initialSite(this);
        },
    }
</script>

<style scoped>
    @media only screen and (min-width: 640px) and (max-width: 1077px) {
        .content-main {
            margin-top: 50px;
        }
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .content-main {
            margin-top: 70px;
        }
    }
    .card {
        box-shadow: unset;
    }
</style>